import React from 'react';
import { Field } from 'react-final-form';
import { makeStyles } from '@material-ui/styles';
const useStyles = ({ position, left, top, width }) => makeStyles(() => ({
    checkboxContainer: {
        display: 'flex',
        flexDirection: 'column',
        position,
        left,
        top,
        width: width + 20,
        textAlign: 'center',
        fontSize: 14,
        '& .MuiIconButton-label': { position: 'absolute', left: 2, top: -5 },
    },
    ellipsis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
}));
export const ChartCheckbox = ({ label, style: { left, position, top, width }, input }) => {
    const classes = useStyles({ position, left, top, width })();
    return (React.createElement("div", { className: classes.checkboxContainer },
        React.createElement("label", { title: label, className: classes.ellipsis }, label),
        React.createElement("input", { type: "checkbox", ...input, checked: !!input.value })));
};
export const AlertBarChartForm = ({ items, handleSubmit, widgetType }) => (React.createElement("form", { id: widgetType, onSubmit: handleSubmit }, items.map((item, index, self) => {
    const { id, width, x, name } = item;
    return (React.createElement(Field, { key: id, name: id }, (props) => (React.createElement(ChartCheckbox, { ...props, label: name, style: {
            position: 'absolute',
            left: self.length > 9 ? x + width / 2 + 32 : x + 68,
            top: -33,
            width,
        } }))));
})));
//# sourceMappingURL=AlertBarChartForm.js.map